<app-form-control>
  <span *ngIf="payload.label" appFormControlLabel>{{ payload.label }}</span>
  <app-selection appFormControlInput [formControl]="formControl" [items]="$any(payload.options)"></app-selection>
  <span *ngIf="payload.hint" appFormControlHint>{{ payload.hint }}</span>
</app-form-control>
